import { useId } from 'react';

interface Props {
  size?: number;
  className?: string;
  title?: string;
}

/** AIトレードアリーナ — 3メーカー比較・総資産推移を象徴するマーク */
export default function GaisukeArenaMark({ size = 64, className, title = 'AI Trade Arena' }: Props) {
  const uid = useId().replace(/:/g, '');
  const bg = `gaisukeArenaBg-${uid}`;
  const bar = `gaisukeArenaBar-${uid}`;
  const line = `gaisukeArenaLine-${uid}`;
  const glow = `gaisukeArenaGlow-${uid}`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      className={className}
      role="img"
      aria-label={title}
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <linearGradient id={bg} x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#ecfeff" />
          <stop offset="55%" stopColor="#e0f2fe" />
          <stop offset="100%" stopColor="#f5f3ff" />
        </linearGradient>
        <linearGradient id={bar} x1="0%" y1="100%" x2="0%" y2="0%">
          <stop offset="0%" stopColor="#0369a1" />
          <stop offset="100%" stopColor="#38bdf8" />
        </linearGradient>
        <linearGradient id={line} x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" stopColor="#0ea5e9" />
          <stop offset="45%" stopColor="#6366f1" />
          <stop offset="100%" stopColor="#a855f7" />
        </linearGradient>
        <radialGradient id={glow} cx="50%" cy="35%" r="55%">
          <stop offset="0%" stopColor="#ffffff" stopOpacity="0.9" />
          <stop offset="100%" stopColor="#ffffff" stopOpacity="0" />
        </radialGradient>
      </defs>

      <rect x="3" y="3" width="58" height="58" rx="16" fill={`url(#${bg})`} />
      <rect
        x="3"
        y="3"
        width="58"
        height="58"
        rx="16"
        fill={`url(#${glow})`}
        stroke="#7dd3fc"
        strokeWidth="1.2"
      />

      {/* 3 メーカーパネル（高さ差 = 成績差） */}
      <rect x="11" y="37" width="11" height="17" rx="3" fill={`url(#${bar})`} opacity="0.82" />
      <rect x="26.5" y="29" width="11" height="25" rx="3" fill={`url(#${bar})`} opacity="0.95" />
      <rect x="42" y="33" width="11" height="21" rx="3" fill={`url(#${bar})`} opacity="0.78" />

      {/* 総資産折れ線 */}
      <path
        d="M16.5 36 L31.5 28 L46.5 32 L52 20"
        fill="none"
        stroke={`url(#${line})`}
        strokeWidth="2.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* AI ノード（3社） */}
      <circle cx="16.5" cy="34" r="2.8" fill="#6366f1" stroke="#fff" strokeWidth="1.2" />
      <circle cx="31.5" cy="26" r="2.8" fill="#8b5cf6" stroke="#fff" strokeWidth="1.2" />
      <circle cx="46.5" cy="30" r="2.8" fill="#0ea5e9" stroke="#fff" strokeWidth="1.2" />

      {/* 週次戦略会議→約定（月8:00→翌営業日7:30）の流れを示す小さな弧 */}
      <path
        d="M48 11 A6 6 0 0 1 56 11"
        fill="none"
        stroke="#0284c7"
        strokeWidth="1.6"
        strokeLinecap="round"
        opacity="0.75"
      />
      <circle cx="48" cy="11" r="1.4" fill="#0284c7" />
      <circle cx="56" cy="11" r="1.4" fill="#38bdf8" />
    </svg>
  );
}
